import React from "react";
import LegalPage from "./LegalPage";

export default function ReturnsPage() {
  return (
    <LegalPage
      eyebrow="Policy · House Rules"
      title="Returns|Refunds."
      updated="February 2026"
      summary="Play it. Break it in. If House Rules isn't the loudest game night you've ever had, send it back within 30 days for a full refund. No essays, no restocking fees."
      sections={[
        {
          id: "guarantee",
          heading: "30-day money-back guarantee",
          body: [
            "Every House Rules box is covered by our 30-day guarantee, starting the day your order is delivered. If you're not obsessed with it, we'll refund your order in full - even if the shrink wrap is torn and the cards have already ruined a friendship.",
            "The guarantee applies to the original purchase price. Original shipping is refunded on defective items only.",
          ],
        },
        {
          id: "how",
          heading: "How to start a return",
          body: [
            [
              "Reply to your order confirmation email or write to hello@houserules.game with your order ID",
              "Tell us what happened - a sentence is enough (we're building a better v2)",
              "We'll send a prepaid return label (US orders) or reimburse return postage (international)",
              "Once we scan your return, we refund the original payment method within 3–5 business days",
            ],
          ],
        },
        {
          id: "eligibility",
          heading: "What we can and can't accept",
          body: [
            "We can accept: opened and gently used boxes, misprint cards, damaged-in-transit orders, and unopened boxes bought within 30 days.",
            "We can't accept: personalized bundle sets after 30 days, or items that have been visibly abused (chewed by pets, soaked in beer, sold to a friend and back).",
          ],
        },
        {
          id: "exchanges",
          heading: "Exchanges & replacements",
          body: [
            "Prefer a swap instead of a refund? Replies are faster than website forms - email hello@houserules.game and we'll cover shipping both ways within the US.",
            "For missing or damaged cards inside a box, we'll ship replacement cards free within 5 business days.",
          ],
        },
      ]}
      related={[
        { label: "Shipping Info", to: "/shipping" },
        { label: "Track Order", to: "/orders/track" },
        { label: "Terms & Conditions", to: "/terms" },
      ]}
    />
  );
}
